import React from 'react';

// Shared layouts
import { Dashboard as DashboardLayout } from 'layouts';

// Component styles
import { makeStyles } from '@mui/styles';
import styles from './style';
import AllCardsHomeworksTable from './components/AllCardsHomeworksTable';
const useStyle = makeStyles(styles);

export function AllCardsHomeworks() {
  const classes = useStyle();

  return (
    <DashboardLayout>
      <div className={classes.root}>
        <div className={classes.content}>
          <AllCardsHomeworksTable />
        </div>
      </div>
    </DashboardLayout>
  );
}
